/**
 * Oracle API Service
 * Backend ile tüm Oracle endpoint iletişimi
 */

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Oracle konfigürasyonunu getir
 */
export async function getOracleConfig() {
  const response = await fetch(`${API_URL}/api/oracle/config`);
  if (!response.ok) throw new Error('Config yüklenemedi');
  return response.json();
}

/**
 * Kullanıcının Oracle paket erişim yetkisini getir
 * Admin test mode ve Elite membership kontrolü
 */
export async function getEntitlement(token) {
  const response = await fetch(`${API_URL}/api/oracle/entitlement`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) throw new Error('Entitlement yüklenemedi');
  return response.json();
}

/**
 * Yeni açılım başlat
 */
export async function startReading(token, data) {
  const response = await fetch(`${API_URL}/api/oracle/start`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Açılım başlatılamadı');
  }
  
  return response.json();
}

/**
 * Açılım durumunu getir (polling için)
 */
export async function getReadingStatus(token, readingId) {
  const response = await fetch(`${API_URL}/api/oracle/status/${readingId}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) throw new Error('Durum alınamadı');
  return response.json();
}

/**
 * Tamamlanmış açılım sonucunu getir
 */
export async function getReadingResult(token, readingId) {
  const response = await fetch(`${API_URL}/api/oracle/result/${readingId}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Sonuç alınamadı');
  }
  
  return response.json();
}

/**
 * Kullanıcının açılım geçmişini getir
 */
export async function getReadingHistory(token, limit = 10) {
  const response = await fetch(`${API_URL}/api/oracle/history?limit=${limit}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) throw new Error('Geçmiş alınamadı');
  return response.json();
}

/**
 * Takip sorusu gönder
 */
export async function sendFollowup(token, readingId, question) {
  const response = await fetch(`${API_URL}/api/oracle/followup`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ reading_id: readingId, question })
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Soru gönderilemedi');
  }
  
  return response.json();
}

/**
 * Base64'e çevir (fotoğraf için)
 */
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

/**
 * Fotoğraf boyutunu küçült (performans için)
 */
export function resizeImage(file, maxWidth = 1024) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    img.onload = () => {
      let { width, height } = img;
      
      if (width > maxWidth) {
        height = (height * maxWidth) / width;
        width = maxWidth;
      }
      
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      
      canvas.toBlob(
        blob => resolve(blob),
        'image/jpeg',
        0.85
      );
    };
    
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}
